const regionsMapping = {
  'Nordeste': 'region-nordeste',
  'Norte': 'region-norte',
  'Sudeste': 'region-sudeste',
  'Centro-Oeste': 'region-centro-oeste',
  'Sul': 'region-sul'
};

const stateMapping = {
  'bahia': {shape: 'shape-ba', label: 'label-icon-state-ba'},
  'piaui': {shape: 'shape-pi', label: 'label-icon-state-pi'},
  'ceara': {shape: 'shape-ce', label: 'label-icon-state-ce'},
  'maranhao': {shape: 'shape-ma', label: 'label-icon-state-ma'},
  'rio-grande-do-norte': {shape: 'shape-rn', label: 'label-icon-state-rn'},
  'sergipe': {shape: 'shape-se', label: 'label-icon-state-se'},
  'pernambuco': {shape: 'shape-pe', label: 'label-icon-state-pe'},
  'alagoas': {shape: 'shape-al', label: 'label-icon-state-al'},
  'paraiba': {shape: 'shape-pb', label: 'label-icon-state-pb'},
  'amazonas': {shape: 'shape-am', label: 'label-icon-state-am'},
  'para': {shape: 'shape-pa', label: 'label-icon-state-pa'},
  'rondonia': {shape: 'shape-ro', label: 'label-icon-state-ro'},
  'acre': {shape: 'shape-ac', label: 'label-icon-state-ac'},
  'amapa': {shape: 'shape-ap', label: 'label-icon-state-ap'},
  'roraima': {shape: 'shape-rr', label: 'label-icon-state-rr'},
  'tocantins': {shape: 'shape-to', label: 'label-icon-state-to'},
  'espirito-santo': {shape: 'shape-es', label: 'label-icon-state-es'},
  'sao-paulo': {shape: 'shape-sp', label: 'label-icon-state-sp'},
  'rio-de-janeiro': {shape: 'shape-rj', label: 'label-icon-state-rj'},
  'minas-gerais': {shape: 'shape-mg', label: 'label-icon-state-mg'},
  'rio-grande-do-sul': {shape: 'shape-rs', label: 'label-icon-state-rs'},
  'santa-catarina': {shape: 'shape-sc', label: 'label-icon-state-sc'},
  'parana': {shape: 'shape-pr', label: 'label-icon-state-pr'},
  'mato-grosso-do-sul': {shape: 'shape-ms', label: 'label-icon-state-ms'},
  'mato-grosso': {shape: 'shape-mt', label: 'label-icon-state-mt'},
  'goias': {shape: 'shape-go', label: 'label-icon-state-go'},
  'distrito-federal': {shape: 'shape-df', label: 'label-icon-state-df'}
};

export {regionsMapping, stateMapping};
